export default __webpack_public_path__ + "media/images/jqueryui/calendar-bd5b71fb7b6f5385fda7fcc7646f0e2d.png";